module.exports = __webpack_public_path__ + "img/fabulous4.7d6c4eff.svg";